import type { Memory } from '../services/api';

export function memoryHasAudio(memory: Memory): boolean {
  const meta = memory.metadata;
  if (!meta || typeof meta !== 'object') {
    return false;
  }
  if (meta.has_audio === true) {
    return true;
  }
  return (
    typeof meta.audio_transcription === 'string' &&
    meta.audio_transcription.length > 0
  );
}

/** Returns URL only if the UI can use it in an audio element (https only). */
export function getPlayableMemoryAudioUrl(memory: Memory): string | null {
  const meta = memory.metadata;
  if (!meta || typeof meta !== 'object') {
    return null;
  }
  const url = meta.audio_url;
  if (typeof url !== 'string' || !url.startsWith('https://')) {
    return null;
  }
  return url;
}

export function getMemoryAudioTranscription(memory: Memory): string | null {
  const meta = memory.metadata;
  if (!meta || typeof meta !== 'object') {
    return null;
  }
  const t = meta.audio_transcription;
  return typeof t === 'string' && t.length > 0 ? t : null;
}
